import "tailwindcss/tailwind.css";
import "./src/styles/global.css";

import wrapWithProvider from "./wrap-with-provider";
export const wrapRootElement = wrapWithProvider;
